import { SET_CATEGORIES } from '../constants/action-types'

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = []

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORIES:
      return action.products

    default:
      return state
  }
}
const persistConfig = {
  keyPrefix: 'happymall-',
  key: 'categories',
  storage,
}

export default persistReducer(persistConfig, categoryReducer)
